export default __webpack_public_path__ + "static/media/car.01ee9b4d.svg";